import { useIsBrowserInit } from 'hooks/use-is-browser-init'

const DisableSSR = ({ children }) => {
  const isBrowserInit = useIsBrowserInit()

  return isBrowserInit ? children : null
}

export default DisableSSR
